import { Translator } from 'Translator';

export type PayPal = { paypalEmail: string };

export type ValidCountryName = 'billingCountry' | 'accountHolderCountry';

export type BankFields =
  | 'bankAccountNumber'
  | 'bankPhoneNumber'
  | 'bankAccountCuitCuil'
  | 'bankAccountType'
  | 'bankBranchCode'
  | 'bankBsbCode'
  | 'bankCode'
  | 'bankBusinessNumber'
  | 'bankSwiftCode'
  | 'bankClabe'
  | 'bankRut'
  | 'bankIBAN'
  | 'bankIfscCode'
  | 'bankCpf'
  | 'bankAbartn'
  | 'accountHolderName'
  | 'bankRegion';

export type AccountHolderFields =
  | 'accountHolderAddress'
  | 'accountHolderCity'
  | 'accountHolderPostCode'
  | 'accountHolderState'
  | 'accountHolderPhoneNumber'
  | 'accountHolderIdNumber'
  | 'accountHolderIdDocumentType'
  | 'accountHolderEmail'
  | 'accountHolderDateOfBirth';

export type PayPalFields = 'paypalEmail';

export type OtherFields = 'institutionNumber' | 'transitNumber';

export type StripeConnectFields = {
  stripeConnectAccountId?: string;
  canAcceptPayouts?: boolean;
};
export type StripeConnect = StripeConnectFields;

export type BankDetails = {
  [k in BankFields | AccountHolderFields | ValidCountryName]?: any;
};

export type PayoutFieldName =
  | BankFields
  | AccountHolderFields
  | PayPalFields
  | OtherFields
  | ValidCountryName
  | keyof StripeConnectFields;
export const PaymentFieldNiceNamesDefault: { [k in PayoutFieldName]: string } =
  {
    billingCountry: 'Billing Country',
    bankAccountNumber: 'Bank Account Number',
    bankPhoneNumber: 'Bank Phone Number',
    bankAccountCuitCuil: 'Bank Account CUIT / CUIL',
    bankAccountType: 'Bank Account Type',
    bankIBAN: 'IBAN',
    bankBranchCode: 'Bank Branch Code',
    bankBsbCode: 'Bank BSB Code',
    bankCode: 'Bank Code',
    bankSwiftCode: 'Bank SWIFT Code',
    bankClabe: 'Bank CLABE',
    bankRegion: 'Bank Region',
    bankAbartn: 'Bank Routing Number',
    bankCpf: 'Bank CPF',
    bankRut: 'Rol Único Tributario',
    bankIfscCode: 'Bank IFSC Code',
    bankBusinessNumber: 'Bank Business Number',
    accountHolderName: 'Account Holder Name',
    accountHolderCity: 'Account Holder City of Residence',
    accountHolderCountry: 'Account Holder Country of Residence',
    accountHolderPostCode: 'Account Holder Post Code',
    accountHolderState: 'Account Holder State',
    accountHolderAddress: 'Account Holder Address',
    accountHolderPhoneNumber: 'Account Holder Phone Number',
    accountHolderIdNumber: 'Account Holder ID Number',
    accountHolderIdDocumentType: 'Account Holder ID Document Type',
    accountHolderEmail: 'Account Holder Email Address',
    accountHolderDateOfBirth: 'Account Holder Date of Birth',
    paypalEmail: 'PayPal Email Address',
    institutionNumber: 'Institution Number',
    transitNumber: 'Transit Number',
    stripeConnectAccountId: 'Stripe Connect Account Identifier',
    canAcceptPayouts: 'Configuration completed?',
  };

export const getPaymentFieldNiceName = (payoutFieldName: PayoutFieldName) =>
  Translator.translate(
    `HostPayoutForm.PayoutField.${payoutFieldName}`,
    {},
    true,
    PaymentFieldNiceNamesDefault[payoutFieldName] ?? payoutFieldName,
  );
